<script>
    const logo = [
        'facebook',
        ' twitter ',
        ' linkedin',
        ' insta',
        'youtube',
        'mail',
        'whatsapp',
    ];
</script>

<div class="container-fluid desktop footpadding  text-white p-5">
    <div style="width:90%; margin:auto;">
        <div class="row p-5">
            <div class="col-md-12 col-xl-12">
                <div class="img">
                    <ul
                        class="d-flex justify-content-between list-unstyled align-items-baseline"
                        style="width: 45vw; margin:auto; padding:0vw 0 5vw;"
                    >
                        <li>
                            <div
                                class="logo_img"
                                on:click={() =>
                                    (location.href =
                                        'https://www.facebook.com/DraperUniversity')}
                                on:mouseenter={() => {
                                    logo.facebook.style.fill = '#f7e05f';
                                    logo.facebook.style.transform =
                                        'scale(1.2)';
                                    logo.facebook.style.transitionDuration =
                                        '0.3s';
                                }}
                                on:mouseleave={() => {
                                    logo.facebook.style.fill = 'white';
                                    logo.facebook.style.transform = 'scale(1)';
                                }}
                            >
                                <svg
                                    width="100%"
                                    height="100%"
                                    viewBox="0 0 17 50"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M17 0.256189V5.63617H13.9315C11.4979 5.63617 11.0394 6.84392 11.0394 8.56405V12.4435H16.8236L16.0477 18.4822H11.0394V34H5.0083V18.4822H0V12.4435H5.0083V7.97847C5.0083 2.81808 8.07676 0 12.5207 0C14.6369 0 16.471 0.146394 17 0.256189Z"
                                        fill="white"
                                        bind:this={logo.facebook}
                                    />
                                </svg>
                            </div>
                        </li>
                        <li>
                            <div
                                class="logo_img"
                                on:click={() =>
                                    (location.href =
                                        'https://twitter.com/draper_u')}
                                on:mouseenter={() => {
                                    logo.twitter.style.fill = '#f7e05f';
                                    logo.twitter.style.transform = 'scale(1.2)';
                                    logo.twitter.style.transitionDuration =
                                        '0.3s';
                                }}
                                on:mouseleave={() => {
                                    logo.twitter.style.fill = 'white';
                                    logo.twitter.style.transform = 'scale(1)';
                                }}
                            >
                                <svg
                                    width="100%"
                                    height="100%"
                                    viewBox="0 0 39 50"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style="margin-top: 0.3vw;"
                                >
                                    <path
                                        d="M38.4058 4.22732C37.0142 4.84399 35.5192 5.26066 33.9475 5.44899C35.5692 4.47864 36.7824 2.95143 37.3608 1.15232C35.8372 2.0573 34.1697 2.69431 32.4308 3.03566C31.2615 1.7871 29.7126 0.959533 28.0247 0.681446C26.3368 0.403359 24.6043 0.690308 23.0962 1.49774C21.5881 2.30518 20.3888 3.58793 19.6844 5.14683C18.9801 6.70573 18.8101 8.45357 19.2008 10.119C16.1136 9.96398 13.0935 9.16157 10.3365 7.76383C7.57953 6.36609 5.14723 4.40426 3.1975 2.00566C2.53083 3.15566 2.1475 4.48899 2.1475 5.90899C2.14676 7.18731 2.46155 8.44606 3.06396 9.57354C3.66637 10.701 4.53777 11.6624 5.60083 12.3723C4.36796 12.3331 3.16229 12 2.08417 11.4007V11.5007C2.08404 13.2936 2.70422 15.0313 3.83947 16.419C4.97472 17.8067 6.55512 18.7589 8.3125 19.114C7.16881 19.4235 5.96973 19.4691 4.80583 19.2473C5.30166 20.79 6.26749 22.139 7.56811 23.1055C8.86873 24.072 10.439 24.6076 12.0592 24.6373C9.30889 26.7963 5.91231 27.9675 2.41583 27.9623C1.79647 27.9625 1.17763 27.9263 0.5625 27.854C4.11163 30.1359 8.24307 31.347 12.4625 31.3423C26.7458 31.3423 34.5542 19.5123 34.5542 9.25232C34.5542 8.91899 34.5458 8.58232 34.5308 8.24899C36.0496 7.15061 37.3607 5.79048 38.4025 4.23232L38.4058 4.22732Z"
                                        fill="white"
                                        bind:this={logo.twitter}
                                    />
                                </svg>
                            </div>
                        </li>
                        <li>
                            <div
                                class="logo_img"
                                on:click={() =>
                                    (location.href =
                                        'https://www.linkedin.com/school/draperuniversity/')}
                                on:mouseenter={() => {
                                    logo.linkedin.style.fill = '#f7e05f';
                                    logo.linkedin.style.transform =
                                        'scale(1.2)';
                                    logo.linkedin.style.transitionDuration =
                                        '0.3s';
                                }}
                                on:mouseleave={() => {
                                    logo.linkedin.style.fill = 'white';
                                    logo.linkedin.style.transform = 'scale(1)';
                                }}
                            >
                                <svg
                                    width="100%"
                                    height="100%"
                                    viewBox="0 0 36 50"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M8.17199 36V11.7109H0.455282V36H8.17199ZM4.31463 8.39261C7.00558 8.39261 8.68057 6.52748 8.68057 4.1967C8.63043 1.81336 7.00569 0 4.3657 0C1.72612 0 0 1.81339 0 4.1967C0 6.52759 1.67457 8.39261 4.26426 8.39261H4.31439H4.31463ZM12.4432 36H20.1599V22.4358C20.1599 21.7098 20.21 20.9847 20.4138 20.4657C20.9716 19.0153 22.2413 17.5131 24.373 17.5131C27.1654 17.5131 28.2825 19.7405 28.2825 23.0057V35.9999H35.9987V22.0727C35.9987 14.612 32.1917 11.1406 27.1146 11.1406C22.9517 11.1406 21.1239 13.575 20.1085 15.2331H20.16V11.7104H12.4433C12.5446 13.9895 12.4433 35.9995 12.4433 35.9995L12.4432 36Z"
                                        fill="white"
                                        bind:this={logo.linkedin}
                                    />
                                </svg>
                            </div>
                        </li>
                        <li>
                            <div
                                class="logo_img"
                                on:click={() =>
                                    (location.href =
                                        'http://www.instagram.com/draperuniversity')}
                                on:mouseenter={() => {
                                    logo.insta.style.fill = '#f7e05f';
                                    logo.insta.style.transform = 'scale(1.2)';
                                    logo.insta.style.transitionDuration =
                                        '0.3s';
                                }}
                                on:mouseleave={() => {
                                    logo.insta.style.fill = 'white';
                                    logo.insta.style.transform = 'scale(1)';
                                }}
                            >
                                <svg
                                    width="100%"
                                    height="100%"
                                    viewBox="0 0 32 50"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style="margin-top: 0.5vw;"
                                >
                                    <path
                                        d="M16.0012 10.7941C13.134 10.7941 10.7941 13.134 10.7941 16.0012C10.7941 18.8683 13.134 21.2082 16.0012 21.2082C18.8684 21.2082 21.2082 18.8683 21.2082 16.0012C21.2082 13.134 18.8684 10.7941 16.0012 10.7941ZM31.6184 16.0012C31.6184 13.8449 31.6379 11.7082 31.5168 9.55585C31.3957 7.05585 30.8254 4.8371 28.9973 3.00897C27.1652 1.17694 24.9504 0.610537 22.4504 0.489443C20.2941 0.368349 18.1574 0.387881 16.0051 0.387881C13.8488 0.387881 11.7121 0.368349 9.55976 0.489443C7.05976 0.610537 4.84101 1.18085 3.01288 3.00897C1.18085 4.841 0.614443 7.05585 0.493349 9.55585C0.372256 11.7121 0.391787 13.8488 0.391787 16.0012C0.391787 18.1535 0.372256 20.2941 0.493349 22.4465C0.614443 24.9465 1.18476 27.1652 3.01288 28.9933C4.84491 30.8254 7.05976 31.3918 9.55976 31.5129C11.716 31.634 13.8527 31.6144 16.0051 31.6144C18.1613 31.6144 20.298 31.634 22.4504 31.5129C24.9504 31.3918 27.1691 30.8215 28.9973 28.9933C30.8293 27.1613 31.3957 24.9465 31.5168 22.4465C31.6418 20.2941 31.6184 18.1574 31.6184 16.0012ZM16.0012 24.0129C11.5676 24.0129 7.98944 20.4348 7.98944 16.0012C7.98944 11.5676 11.5676 7.98944 16.0012 7.98944C20.4348 7.98944 24.0129 11.5676 24.0129 16.0012C24.0129 20.4348 20.4348 24.0129 16.0012 24.0129ZM24.341 9.53241C23.3059 9.53241 22.4699 8.69647 22.4699 7.66132C22.4699 6.62616 23.3059 5.79022 24.341 5.79022C25.3762 5.79022 26.2121 6.62616 26.2121 7.66132C26.2124 7.90712 26.1642 8.15057 26.0703 8.37772C25.9764 8.60487 25.8386 8.81126 25.6648 8.98507C25.4909 9.15888 25.2846 9.29669 25.0574 9.39061C24.8303 9.48453 24.5868 9.53272 24.341 9.53241Z"
                                        fill="white"
                                        bind:this={logo.insta}
                                    />
                                </svg>
                            </div>
                        </li>
                        <li>
                            <div
                                class="logo_img"
                                on:mouseenter={() => {
                                    logo.youtube.style.fill = '#f7e05f';
                                    logo.youtube.style.transform = 'scale(1.2)';
                                    logo.youtube.style.transitionDuration =
                                        '0.3s';
                                }}
                                on:mouseleave={() => {
                                    logo.youtube.style.fill = 'white';
                                    logo.youtube.style.transform = 'scale(1)';
                                }}
                                on:click={() =>
                                    (location.href =
                                        'https://www.youtube.com/c/DraperTV')}
                            >
                                <svg
                                    width="100%"
                                    height="100%"
                                    viewBox="0 0 39 50"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style="margin-top: 0.8vw;"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M36.8731 2.1352C37.4786 2.75356 37.915 3.52311 38.1387 4.36722V4.36738C39.4267 9.66156 39.1292 18.023 38.1637 23.5216C37.94 24.3657 37.5036 25.1353 36.898 25.7536C36.2924 26.372 35.5387 26.8176 34.712 27.046C31.6857 27.8888 19.5051 27.8888 19.5051 27.8888C19.5051 27.8888 7.32426 27.8888 4.2978 27.046C3.47112 26.8175 2.71748 26.3719 2.11192 25.7536C1.50635 25.1352 1.07 24.3657 0.846299 23.5216C-0.449385 18.2504 -0.0942715 9.88369 0.821162 4.39289C1.04484 3.54875 1.48118 2.77916 2.08675 2.16078C2.69231 1.54239 3.44597 1.09678 4.27266 0.868311C7.29912 0.025511 19.4802 0 19.4802 0C19.4802 0 31.6607 0 34.6872 0.8428C35.5139 1.07125 36.2675 1.51684 36.8731 2.1352ZM25.7062 13.9449L15.6016 19.921V7.96875L25.7062 13.9449Z"
                                        fill="white"
                                        bind:this={logo.youtube}
                                    />
                                </svg>
                            </div>
                        </li>
                        <li>
                            <div
                                class="logo_img"
                                on:click={() =>
                                    (location.href =
                                        'mailto:info@draperuniversity.com')}
                                on:mouseenter={() => {
                                    logo.mail.style.fill = '#f7e05f';
                                    logo.mail.style.transform = 'scale(1.2)';
                                    logo.mail.style.transitionDuration = '0.3s';
                                }}
                                on:mouseleave={() => {
                                    logo.mail.style.fill = 'white';
                                    logo.mail.style.transform = 'scale(1)';
                                }}
                            >
                                <svg
                                    width="100%"
                                    height="100%"
                                    viewBox="0 0 37 50"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style="margin-top: 1vw;"
                                >
                                    <path
                                        d="M2.07243 3.30848L16.6974 11.165C17.1888 11.4283 17.8245 11.5531 18.4641 11.5531C19.1037 11.5531 19.7394 11.4283 20.2308 11.165L34.8558 3.30848C35.8094 2.79563 36.7103 0.800781 34.9611 0.800781H1.96908C0.219928 0.800781 1.12083 2.79563 2.07243 3.30848ZM35.2985 7.60433L20.2308 15.457C19.5678 15.8041 19.1037 15.845 18.4641 15.845C17.8245 15.845 17.3604 15.8041 16.6974 15.457C16.0344 15.1099 2.78808 8.16593 1.70583 7.60238C0.945328 7.20458 0.953128 7.67063 0.953128 8.02943V22.2508C0.953128 23.0698 2.05683 24.2008 2.90313 24.2008H34.1031C34.9494 24.2008 36.0531 23.0698 36.0531 22.2508V8.03138C36.0531 7.67258 36.0609 7.20653 35.2985 7.60433Z"
                                        fill="white"
                                        bind:this={logo.mail}
                                    />
                                </svg>
                            </div>
                        </li>
                        <li>
                            <a
                                href="https://api.whatsapp.com/send?phone=16504279813
                            "
                            >
                                <div
                                    class="logo_img"
                                    on:mouseenter={() => {
                                        logo.whatsapp.style.fill = '#f7e05f';
                                        logo.whatsapp.style.transform =
                                            'scale(1.2)';
                                        logo.whatsapp.style.transitionDuration =
                                            '0.3s';
                                    }}
                                    on:mouseleave={() => {
                                        logo.whatsapp.style.fill = 'white';
                                        logo.whatsapp.style.transform =
                                            'scale(1)';
                                    }}
                                >
                                    <svg
                                        width="100%"
                                        height="100%"
                                        viewBox="0 0 37 50"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M23.5443 20.3655C24.378 20.6278 25.1767 20.9902 25.9231 21.4447L25.8753 21.4169C26.6909 21.7792 27.3954 22.2032 28.0383 22.7011L28.0152 22.6842C28.046 22.7782 28.0645 22.8846 28.0645 22.9971L28.063 23.0465V23.0449C28.0398 23.7063 27.8934 24.3276 27.6452 24.8934L27.6575 24.861C27.3014 25.5748 26.7078 26.1252 25.9817 26.4181L25.9601 26.4258C25.2088 26.8186 24.3779 27.0353 23.5305 27.0594H23.5212C21.9036 26.8514 20.3403 26.3377 18.9147 25.5455L18.981 25.5794C17.4668 24.8935 16.0898 23.938 14.9172 22.7597L14.9156 22.7582C13.6366 21.4265 12.477 19.9852 11.45 18.4508L11.3775 18.3367C10.3583 17.0045 9.76706 15.3946 9.68167 13.7194L9.68012 13.6994V13.5082C9.70274 12.7926 9.87077 12.0891 10.174 11.4406C10.4772 10.792 10.9092 10.212 11.4438 9.73573L11.4484 9.7311C11.7786 9.40209 12.2234 9.21369 12.6895 9.2054H12.691C12.8467 9.21002 12.9962 9.22235 13.1412 9.24394L13.1211 9.24085C13.2552 9.26089 13.411 9.27323 13.5713 9.27631H13.5759C13.8004 9.25449 14.0255 9.30996 14.2142 9.43356L14.2111 9.43202C14.376 9.61394 14.5025 9.83439 14.578 10.0764L14.5811 10.0888C14.7085 10.4074 14.9716 11.1083 15.3704 12.1916C15.5785 12.6757 15.782 13.2723 15.9455 13.8859L15.967 13.983C15.8558 14.5196 15.5662 15.0027 15.1453 15.3536L15.1407 15.3566C14.5908 15.9384 14.3159 16.3084 14.3159 16.4666C14.3218 16.5964 14.3652 16.7217 14.4408 16.8274L14.4392 16.8259C15.0355 18.0585 15.8599 19.167 16.8689 20.0926L16.8766 20.1004C17.9329 21.0519 19.1171 21.851 20.3947 22.4745L20.4857 22.5146C20.6419 22.616 20.8223 22.674 21.0083 22.6826H21.0114C21.2508 22.6826 21.6815 22.2962 22.3033 21.5233C22.9251 20.7504 23.3383 20.364 23.5428 20.364L23.5443 20.3655ZM18.6927 33.0319H18.7266C20.7509 33.0348 22.7536 32.6152 24.6065 31.8001L24.5125 31.8371C28.1447 30.3046 30.9767 27.4726 32.4721 23.9376L32.5091 23.8404C33.2645 22.1246 33.7039 20.1235 33.7039 18.0206C33.7039 15.9178 33.2645 13.9167 32.4721 12.1053L32.5091 12.2009C30.9767 8.56869 28.1447 5.73665 24.6096 4.24123L24.5125 4.20423C22.7966 3.44881 20.7955 3.00944 18.6927 3.00944C16.5899 3.00944 14.5888 3.44881 12.7773 4.24123L12.8729 4.20423C9.24075 5.73665 6.40871 8.56869 4.91329 12.1037L4.87629 12.2009C4.08141 14.0443 3.6747 16.0317 3.6815 18.0391C3.67652 21.2132 4.69208 24.3047 6.57829 26.8575L6.549 26.8174L4.66046 32.3874L10.4448 30.5467C12.8612 32.1742 15.71 33.0398 18.6233 33.0319H18.6958H18.6927ZM18.6927 0.000104733H18.7436C21.2534 0.000104733 23.6399 0.527355 25.7967 1.47856L25.6842 1.43385C30.0394 3.27923 33.4357 6.67552 35.2363 10.9136L35.281 11.0307C36.1875 13.0919 36.7148 15.4954 36.7148 18.0222C36.7148 20.549 36.1875 22.9524 35.2363 25.1277L35.281 25.0136C33.4357 29.3689 30.0394 32.7651 25.8013 34.5658L25.6842 34.6105C23.6384 35.517 21.2519 36.0443 18.742 36.0443H18.6896H18.6927H18.611C15.4367 36.0443 12.4567 35.2102 9.879 33.7503L9.96687 33.7965L0 37.0001L3.25137 27.32C1.55417 24.5282 0.661085 21.3218 0.670625 18.0546C0.670625 15.517 1.19788 13.1027 2.14908 10.9151L2.10437 11.0307C3.94975 6.67552 7.34604 3.27923 11.5841 1.47856L11.7012 1.43385C13.8909 0.480023 16.255 -0.00822181 18.6434 0.000104733H18.6942H18.6912H18.6927Z"
                                            fill="white"
                                            bind:this={logo.whatsapp}
                                        />
                                    </svg>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class=" col-md-12 col-xl-12 ">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <h3
                            style="font-size:1.984vw!important;font-weight:800;"
                        >
                            <a href="/alumni"> Alumni </a>
                        </h3>
                    </div>
                    <div class="seprator">
                        <h3
                            style="font-size:1.984vw!important;font-weight:800;"
                        >
                            <a href="/about_us"> About </a>
                        </h3>
                    </div>
                    <div class="seprator">
                        <h3
                            style="font-size:1.984vw!important;font-weight:800;"
                        >
                            <a href="/contact_us"> Connect </a>
                        </h3>
                    </div>
                    <div class="seprator">
                        <h3
                            style="font-size:1.984vw!important;font-weight:800;"
                        >
                            <a href="https://www.youtube.com/c/DraperTV">
                                DraperTV
                            </a>
                        </h3>
                    </div>
                    <div class="seprator">
                        <h3
                            style="font-size:1.984vw!important;font-weight:800;"
                        >
                            <a href="/media_center"> Media Center </a>
                        </h3>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-xl-12">
                <div class="row ">
                    <hr class="line" />
                    <div class="text-center">
                        <div>
                            <h4 style="font-size:1.323vw">
                                All rights reserved, Draper University 2023
                            </h4>
                        </div>
                        <br />
                        <div
                            on:click={() => (location.href = '/privacy_policy')}
                        >
                            <h4
                                style="font-size:1.323vw;font-weight:700; cursor:pointer"
                            >
                                Privacy Policy 
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid mobile footpadding" style="color: white;">
    <div class="row" style="padding:8vw 5vw;margin-top:-0.3vw;">
        <div class="col-12 p-0">
            <div class="mobile-logo">
                <ul style="margin: 10vw 0vw;">
                    <li>
                        <div
                            on:click={() =>
                                (location.href =
                                    'https://www.facebook.com/DraperUniversity')}
                        >
                            <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 17 50"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M17 0.256189V5.63617H13.9315C11.4979 5.63617 11.0394 6.84392 11.0394 8.56405V12.4435H16.8236L16.0477 18.4822H11.0394V34H5.0083V18.4822H0V12.4435H5.0083V7.97847C5.0083 2.81808 8.07676 0 12.5207 0C14.6369 0 16.471 0.146394 17 0.256189Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </li>
                    <li>
                        <div
                            on:click={() =>
                                (location.href =
                                    'https://twitter.com/draper_u')}
                        >
                            <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 39 50"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style="margin-top: 0.3vw;"
                            >
                                <path
                                    d="M38.4058 4.22732C37.0142 4.84399 35.5192 5.26066 33.9475 5.44899C35.5692 4.47864 36.7824 2.95143 37.3608 1.15232C35.8372 2.0573 34.1697 2.69431 32.4308 3.03566C31.2615 1.7871 29.7126 0.959533 28.0247 0.681446C26.3368 0.403359 24.6043 0.690308 23.0962 1.49774C21.5881 2.30518 20.3888 3.58793 19.6844 5.14683C18.9801 6.70573 18.8101 8.45357 19.2008 10.119C16.1136 9.96398 13.0935 9.16157 10.3365 7.76383C7.57953 6.36609 5.14723 4.40426 3.1975 2.00566C2.53083 3.15566 2.1475 4.48899 2.1475 5.90899C2.14676 7.18731 2.46155 8.44606 3.06396 9.57354C3.66637 10.701 4.53777 11.6624 5.60083 12.3723C4.36796 12.3331 3.16229 12 2.08417 11.4007V11.5007C2.08404 13.2936 2.70422 15.0313 3.83947 16.419C4.97472 17.8067 6.55512 18.7589 8.3125 19.114C7.16881 19.4235 5.96973 19.4691 4.80583 19.2473C5.30166 20.79 6.26749 22.139 7.56811 23.1055C8.86873 24.072 10.439 24.6076 12.0592 24.6373C9.30889 26.7963 5.91231 27.9675 2.41583 27.9623C1.79647 27.9625 1.17763 27.9263 0.5625 27.854C4.11163 30.1359 8.24307 31.347 12.4625 31.3423C26.7458 31.3423 34.5542 19.5123 34.5542 9.25232C34.5542 8.91899 34.5458 8.58232 34.5308 8.24899C36.0496 7.15061 37.3607 5.79048 38.4025 4.23232L38.4058 4.22732Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </li>
                    <li>
                        <div
                            on:click={() =>
                                (location.href =
                                    'https://www.linkedin.com/school/draperuniversity/')}
                        >
                            <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 36 50"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.17199 36V11.7109H0.455282V36H8.17199ZM4.31463 8.39261C7.00558 8.39261 8.68057 6.52748 8.68057 4.1967C8.63043 1.81336 7.00569 0 4.3657 0C1.72612 0 0 1.81339 0 4.1967C0 6.52759 1.67457 8.39261 4.26426 8.39261H4.31439H4.31463ZM12.4432 36H20.1599V22.4358C20.1599 21.7098 20.21 20.9847 20.4138 20.4657C20.9716 19.0153 22.2413 17.5131 24.373 17.5131C27.1654 17.5131 28.2825 19.7405 28.2825 23.0057V35.9999H35.9987V22.0727C35.9987 14.612 32.1917 11.1406 27.1146 11.1406C22.9517 11.1406 21.1239 13.575 20.1085 15.2331H20.16V11.7104H12.4433C12.5446 13.9895 12.4433 35.9995 12.4433 35.9995L12.4432 36Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </li>
                    <li>
                        <div
                            on:click={() =>
                                (location.href =
                                    'http://www.instagram.com/draperuniversity')}
                        >
                            <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 32 50"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style="margin-top: 0.5vw;"
                            >
                                <path
                                    d="M16.0012 10.7941C13.134 10.7941 10.7941 13.134 10.7941 16.0012C10.7941 18.8683 13.134 21.2082 16.0012 21.2082C18.8684 21.2082 21.2082 18.8683 21.2082 16.0012C21.2082 13.134 18.8684 10.7941 16.0012 10.7941ZM31.6184 16.0012C31.6184 13.8449 31.6379 11.7082 31.5168 9.55585C31.3957 7.05585 30.8254 4.8371 28.9973 3.00897C27.1652 1.17694 24.9504 0.610537 22.4504 0.489443C20.2941 0.368349 18.1574 0.387881 16.0051 0.387881C13.8488 0.387881 11.7121 0.368349 9.55976 0.489443C7.05976 0.610537 4.84101 1.18085 3.01288 3.00897C1.18085 4.841 0.614443 7.05585 0.493349 9.55585C0.372256 11.7121 0.391787 13.8488 0.391787 16.0012C0.391787 18.1535 0.372256 20.2941 0.493349 22.4465C0.614443 24.9465 1.18476 27.1652 3.01288 28.9933C4.84491 30.8254 7.05976 31.3918 9.55976 31.5129C11.716 31.634 13.8527 31.6144 16.0051 31.6144C18.1613 31.6144 20.298 31.634 22.4504 31.5129C24.9504 31.3918 27.1691 30.8215 28.9973 28.9933C30.8293 27.1613 31.3957 24.9465 31.5168 22.4465C31.6418 20.2941 31.6184 18.1574 31.6184 16.0012ZM16.0012 24.0129C11.5676 24.0129 7.98944 20.4348 7.98944 16.0012C7.98944 11.5676 11.5676 7.98944 16.0012 7.98944C20.4348 7.98944 24.0129 11.5676 24.0129 16.0012C24.0129 20.4348 20.4348 24.0129 16.0012 24.0129ZM24.341 9.53241C23.3059 9.53241 22.4699 8.69647 22.4699 7.66132C22.4699 6.62616 23.3059 5.79022 24.341 5.79022C25.3762 5.79022 26.2121 6.62616 26.2121 7.66132C26.2124 7.90712 26.1642 8.15057 26.0703 8.37772C25.9764 8.60487 25.8386 8.81126 25.6648 8.98507C25.4909 9.15888 25.2846 9.29669 25.0574 9.39061C24.8303 9.48453 24.5868 9.53272 24.341 9.53241Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </li>
                    <li>
                        <div
                            on:click={() =>
                                (location.href =
                                    'https://www.youtube.com/c/DraperTV')}
                        >
                            <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 39 50"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style="margin-top: 0.8vw;"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M36.8731 2.1352C37.4786 2.75356 37.915 3.52311 38.1387 4.36722V4.36738C39.4267 9.66156 39.1292 18.023 38.1637 23.5216C37.94 24.3657 37.5036 25.1353 36.898 25.7536C36.2924 26.372 35.5387 26.8176 34.712 27.046C31.6857 27.8888 19.5051 27.8888 19.5051 27.8888C19.5051 27.8888 7.32426 27.8888 4.2978 27.046C3.47112 26.8175 2.71748 26.3719 2.11192 25.7536C1.50635 25.1352 1.07 24.3657 0.846299 23.5216C-0.449385 18.2504 -0.0942715 9.88369 0.821162 4.39289C1.04484 3.54875 1.48118 2.77916 2.08675 2.16078C2.69231 1.54239 3.44597 1.09678 4.27266 0.868311C7.29912 0.025511 19.4802 0 19.4802 0C19.4802 0 31.6607 0 34.6872 0.8428C35.5139 1.07125 36.2675 1.51684 36.8731 2.1352ZM25.7062 13.9449L15.6016 19.921V7.96875L25.7062 13.9449Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </li>
                    <li>
                        <div
                            on:click={() =>
                                (location.href =
                                    'mailto:info@draperuniversity.com')}
                        >
                            <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 37 50"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style="margin-top: 1vw;"
                            >
                                <path
                                    d="M2.07243 3.30848L16.6974 11.165C17.1888 11.4283 17.8245 11.5531 18.4641 11.5531C19.1037 11.5531 19.7394 11.4283 20.2308 11.165L34.8558 3.30848C35.8094 2.79563 36.7103 0.800781 34.9611 0.800781H1.96908C0.219928 0.800781 1.12083 2.79563 2.07243 3.30848ZM35.2985 7.60433L20.2308 15.457C19.5678 15.8041 19.1037 15.845 18.4641 15.845C17.8245 15.845 17.3604 15.8041 16.6974 15.457C16.0344 15.1099 2.78808 8.16593 1.70583 7.60238C0.945328 7.20458 0.953128 7.67063 0.953128 8.02943V22.2508C0.953128 23.0698 2.05683 24.2008 2.90313 24.2008H34.1031C34.9494 24.2008 36.0531 23.0698 36.0531 22.2508V8.03138C36.0531 7.67258 36.0609 7.20653 35.2985 7.60433Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </li>
                    <li>
                        <div>
                            <svg
                                width="100%"
                                height="100%"
                                viewBox="0 0 37 50"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M23.5443 20.3655C24.378 20.6278 25.1767 20.9902 25.9231 21.4447L25.8753 21.4169C26.6909 21.7792 27.3954 22.2032 28.0383 22.7011L28.0152 22.6842C28.046 22.7782 28.0645 22.8846 28.0645 22.9971L28.063 23.0465V23.0449C28.0398 23.7063 27.8934 24.3276 27.6452 24.8934L27.6575 24.861C27.3014 25.5748 26.7078 26.1252 25.9817 26.4181L25.9601 26.4258C25.2088 26.8186 24.3779 27.0353 23.5305 27.0594H23.5212C21.9036 26.8514 20.3403 26.3377 18.9147 25.5455L18.981 25.5794C17.4668 24.8935 16.0898 23.938 14.9172 22.7597L14.9156 22.7582C13.6366 21.4265 12.477 19.9852 11.45 18.4508L11.3775 18.3367C10.3583 17.0045 9.76706 15.3946 9.68167 13.7194L9.68012 13.6994V13.5082C9.70274 12.7926 9.87077 12.0891 10.174 11.4406C10.4772 10.792 10.9092 10.212 11.4438 9.73573L11.4484 9.7311C11.7786 9.40209 12.2234 9.21369 12.6895 9.2054H12.691C12.8467 9.21002 12.9962 9.22235 13.1412 9.24394L13.1211 9.24085C13.2552 9.26089 13.411 9.27323 13.5713 9.27631H13.5759C13.8004 9.25449 14.0255 9.30996 14.2142 9.43356L14.2111 9.43202C14.376 9.61394 14.5025 9.83439 14.578 10.0764L14.5811 10.0888C14.7085 10.4074 14.9716 11.1083 15.3704 12.1916C15.5785 12.6757 15.782 13.2723 15.9455 13.8859L15.967 13.983C15.8558 14.5196 15.5662 15.0027 15.1453 15.3536L15.1407 15.3566C14.5908 15.9384 14.3159 16.3084 14.3159 16.4666C14.3218 16.5964 14.3652 16.7217 14.4408 16.8274L14.4392 16.8259C15.0355 18.0585 15.8599 19.167 16.8689 20.0926L16.8766 20.1004C17.9329 21.0519 19.1171 21.851 20.3947 22.4745L20.4857 22.5146C20.6419 22.616 20.8223 22.674 21.0083 22.6826H21.0114C21.2508 22.6826 21.6815 22.2962 22.3033 21.5233C22.9251 20.7504 23.3383 20.364 23.5428 20.364L23.5443 20.3655ZM18.6927 33.0319H18.7266C20.7509 33.0348 22.7536 32.6152 24.6065 31.8001L24.5125 31.8371C28.1447 30.3046 30.9767 27.4726 32.4721 23.9376L32.5091 23.8404C33.2645 22.1246 33.7039 20.1235 33.7039 18.0206C33.7039 15.9178 33.2645 13.9167 32.4721 12.1053L32.5091 12.2009C30.9767 8.56869 28.1447 5.73665 24.6096 4.24123L24.5125 4.20423C22.7966 3.44881 20.7955 3.00944 18.6927 3.00944C16.5899 3.00944 14.5888 3.44881 12.7773 4.24123L12.8729 4.20423C9.24075 5.73665 6.40871 8.56869 4.91329 12.1037L4.87629 12.2009C4.08141 14.0443 3.6747 16.0317 3.6815 18.0391C3.67652 21.2132 4.69208 24.3047 6.57829 26.8575L6.549 26.8174L4.66046 32.3874L10.4448 30.5467C12.8612 32.1742 15.71 33.0398 18.6233 33.0319H18.6958H18.6927ZM18.6927 0.000104733H18.7436C21.2534 0.000104733 23.6399 0.527355 25.7967 1.47856L25.6842 1.43385C30.0394 3.27923 33.4357 6.67552 35.2363 10.9136L35.281 11.0307C36.1875 13.0919 36.7148 15.4954 36.7148 18.0222C36.7148 20.549 36.1875 22.9524 35.2363 25.1277L35.281 25.0136C33.4357 29.3689 30.0394 32.7651 25.8013 34.5658L25.6842 34.6105C23.6384 35.517 21.2519 36.0443 18.742 36.0443H18.6896H18.6927H18.611C15.4367 36.0443 12.4567 35.2102 9.879 33.7503L9.96687 33.7965L0 37.0001L3.25137 27.32C1.55417 24.5282 0.661085 21.3218 0.670625 18.0546C0.670625 15.517 1.19788 13.1027 2.14908 10.9151L2.10437 11.0307C3.94975 6.67552 7.34604 3.27923 11.5841 1.47856L11.7012 1.43385C13.8909 0.480023 16.255 -0.00822181 18.6434 0.000104733H18.6942H18.6912H18.6927Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </li>
                </ul>
                <div class="col-12" style="padding: 0 12vw;">
                    <div class="">
                        <div>
                            <h3>
                                <a href="/alumni"> Alumni </a>
                            </h3>
                        </div>

                        <div>
                            <h3>
                                <a href="/about_us"> About </a>
                            </h3>
                        </div>

                        <div>
                            <h3>
                                <a href="/contact_us"> Connect </a>
                            </h3>
                        </div>

                        <div>
                            <h3>
                                <a href="https://www.youtube.com/c/DraperTV">
                                    DraperTV
                                </a>
                            </h3>
                        </div>
                        <div>
                            <h3>
                                <a href="/media_center"> Media Center </a>
                            </h3>
                        </div>
                    </div>
                </div>
                <div class="col-12" style="padding:0 8vw;">
                    <div class="row ">
                        <hr class="line " />
                        <div class="">
                            <div
                                on:click={() =>
                                    (location.href = '/privacy_policy')}
                            >
                                <h4
                                    style="font-size:4.444vw;font-weight:700;margin-bottom:6vw;"
                                >
                                Privacy Policy 
                                </h4>
                            </div>
                            <div>
                                <p
                                    style="font-size:3.7vw;color:#FFFFFF;width:100%!important;"
                                >
                                All rights reserved, Draper University 2018-2023
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    a {
        text-decoration: none;
        color: white;
    }
    svg {
        cursor: pointer;
    }
    .seprator {
        position: relative;
    }
    h3 {
        cursor: pointer;
    }
    .seprator::after {
        content: "";
        position: absolute;
        width: 1.8vw;
        border-bottom: 0.2vw solid white;
        top: 1.2vw;
        left: -7.5vw;
    }
    .desktop {
        display: block;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .mobile {
            display: block;
        }
        .line {
            border: 0.045vw solid #f7e05f;
            opacity: 1;
            margin: 10vw 0.5vw;
        }
        h3 {
            font-size: 5.556vw !important;
            font-weight: 800;
            line-height: 10vw;
        }
        .line {
            border: 0.045vw solid #f7e05f;
            opacity: 1;
            margin: 10vw 0.5vw !important;
        }
    }
    .logo_img {
        width: 3.8vw;
        height: 2.8vw;
        overflow: hidden;
    }
    .mobile-logo ul {
        display: flex;
        justify-content: space-between;
        list-style: none;
        margin-bottom: 0;
        padding: 0;
    }
    .mobile-logo ul li div {
        width: 7vw;
        height: 7vw;
    }
    p {
        font-size: 1vw;
        width: 20vw;
        opacity: 1;
    }
    .p-5 {
        padding: 2vw !important;
    }

    .footpadding {
        background: #00204b;
        cursor: default;
    }
    .line {
        border: 0.045vw solid #f7e05f;
        opacity: 1;
        margin: 3vw 0.5vw;
    }
</style>
